import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import "../pages/AddStaff.css"; // ✅ Make sure this file exists for styling

function AddStaff() {
    const { user } = useAuth();
    
    

    // 🔹 State for staff details
    const [name, setName] = useState("");
    const [nickname, setNickname] = useState("");
    const [streetAddress, setStreetAddress] = useState("");
    const [city, setCity] = useState("");
    const [zip, setZip] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [hireDate, setHireDate] = useState("");
    const [role, setRole] = useState("Any job");
    const [availability, setAvailability] = useState([]);
    const [notes, setNotes] = useState("");

    

    // 🔹 Days of the Week for Availability Checkboxes
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    // 🔹 Handle Availability Selection
    const handleAvailabilityChange = (day) => {
        setAvailability(prevAvailability =>
            prevAvailability.includes(day)
                ? prevAvailability.filter(d => d !== day) // Remove if already selected
                : [...prevAvailability, day] // Add if not selected
        );
    };


  


    // 🔹 Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            alert("Name is required!");
            return;
        }

       
    

        try {
           
            
            await addDoc(collection(db, "staff"), {
                name,
                nickname,
                streetAddress,
                city,
                zip,
                phone,
                email,
                hireDate,
                role,
                availability, // Stored as an array in Firestore
                notes,
            });

            

            alert("Staff member added successfully!");

            // 🔹 Reset Form Fields
            setName("");
            setNickname("");
            setStreetAddress("");
            setCity("");
            setZip("");
            setPhone("");
            setEmail("");
            setHireDate("");
            setRole("Any job");
            setAvailability([]);
            setNotes("");
        } catch (error) {
            console.error("Error adding staff member:", error);
            alert("Failed to add staff member.");
        }
    };

    return (
        <div className="add-staff-container">
            <h2>Add Staff</h2>
            <form onSubmit={handleSubmit} className="staff-form">
                <label>Name:</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />

                <label>Nickname:</label>
                <input type="text" value={nickname} onChange={(e) => setNickname(e.target.value)} />

                <label>Street Address:</label>
                <input type="text" value={streetAddress} onChange={(e) => setStreetAddress(e.target.value)} />

                <label>City:</label>
                <input type="text" value={city} onChange={(e) => setCity(e.target.value)} />

                <label>Zip:</label>
                <input type="text" value={zip} onChange={(e) => setZip(e.target.value)} />

                <label>Phone:</label>
                <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />

                <label>Email:</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

                <label>Hire Date:</label>
                <input type="date" value={hireDate} onChange={(e) => setHireDate(e.target.value)} />

                <label>Role:</label>
                <select value={role} onChange={(e) => setRole(e.target.value)}>
                    <option value="Any job">Any job</option>
                    <option value="Small Lead">Small Lead</option>
                    <option value="2nd Shooter">2nd Shooter</option>
                    <option value="Office">Office</option>
                </select>

                <label>Availability:</label>
                <div className="availability-checkboxes">
                    {daysOfWeek.map(day => (
                        <label key={day} className="checkbox-label">
                            <input
                                type="checkbox"
                                checked={availability.includes(day)}
                                onChange={() => handleAvailabilityChange(day)}
                            />
                            {day}
                        </label>
                    ))}
                </div>

                <label>Notes:</label>
                <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows="4"></textarea>

            
       

                <button type="submit" className="submit-button">Add Staff</button>
            </form>
        </div>
    );
}

export default AddStaff;
